// extracted by css-extract-rspack-plugin
export default {"textContainer":"text-container--KR06QyQbAIk7a_3I"};